export default __webpack_public_path__ + "static/media/healinglotus.12892c83.png";